import { cn } from '@studio/ui';
import { useAtom } from 'jotai';
import { Moon, Sun } from 'lucide-react';
import { themeAtom } from '../state/theme';

export interface ThemeToggleProps {
  className?: string;
}

/** Pill-shaped sun/moon toggle. Lives next to the profile avatar in the TopBar. */
export function ThemeToggle({ className }: ThemeToggleProps) {
  const [theme, setTheme] = useAtom(themeAtom);
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      className={cn(
        'inline-flex h-9 w-9 items-center justify-center rounded-pill border border-border bg-surface text-fg-2 transition-colors hover:bg-surface-2 hover:text-fg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring',
        className,
      )}
    >
      {isDark ? <Sun className="h-4 w-4" aria-hidden /> : <Moon className="h-4 w-4" aria-hidden />}
    </button>
  );
}
